import { render, staticRenderFns } from "./LottieLoader.vue?vue&type=template&id=5583865b&scoped=true"
import script from "./LottieLoader.vue?vue&type=script&lang=ts"
export * from "./LottieLoader.vue?vue&type=script&lang=ts"
import style0 from "./LottieLoader.vue?vue&type=style&index=0&id=5583865b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5583865b",
  null
  
)

export default component.exports